import { render, staticRenderFns } from "./AlignmentDropdown.vue?vue&type=template&id=5acb8492&scoped=true"
import script from "./AlignmentDropdown.vue?vue&type=script&lang=js"
export * from "./AlignmentDropdown.vue?vue&type=script&lang=js"
import style0 from "./AlignmentDropdown.vue?vue&type=style&index=0&id=5acb8492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5acb8492",
  null
  
)

export default component.exports